import React from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Login from '../pages/login';
import Signup from '../pages/signup';
import Home from '../pages/homePage';
import Layout from '../layout';
import ProductPage from '../pages/productPage';
import AboutUs from '../pages/about';
import PackingList from '../pages/packingList';
import TravellerProfile from '../pages/travellerProfile';
import { PrivateRouteTraveller, PrivateRouteAdmin, PrivateRouteUser } from '../components/PrivateRoute';
import TermsAndConditions from '../pages/TermsAndConditions';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import AdminLayout from '../pages/adminPanel/layout';
import DestinationPage from '../pages/adminPanel/pages/destination';
import TripDetails from '../pages/tripDetails';
import Dashboard from '../pages/adminPanel/pages/dashboard';
import Packing from '../pages/adminPanel/pages/packingList';
import TravellerDashboard from '../pages/adminPanel/pages/travellerProfile';
import Traveller from '../pages/adminPanel/pages/travellerProfile';
import Itineraries from '../pages/adminPanel/pages/itineraries/Itineraries';
import Tribe from '../pages/adminPanel/pages/tribe/Tribe';
import TagPage from '../pages/adminPanel/pages/tags';
import AddPackingList from '../pages/adminPanel/pages/addPackingList';
import EditPackingList from '../pages/adminPanel/pages/editPackingList';
import Updateprofile from '../pages/Updateprofile';
import TravellerPackingList from '../pages/travellAdminPanel/travellerPackingList';
import TravellerDashboardMain from '../pages/travellAdminPanel/travellerDashboard';
import EditProfiles from '../pages/adminPanel/pages/editProfiles';
import NotFound from '../pages/404_page';
import PackingListSetting from '../pages/adminPanel/pages/packingListSetting';
import AllPackingList from '../pages/allPackingList';
import UserSavedPackingList from '../pages/userSavedPackingList';
import TopSections from '../pages/adminPanel/pages/topSections';
import BadgesPage from '../pages/adminPanel/pages/badges';



const PackingRoutes = () => {
    const router = createBrowserRouter([
        {
            element: <Layout />,
            children: [
                {
                    path: "/",
                    element: <Home />,
                },
                {
                    path: "/products",
                    element: <ProductPage />,
                },
                {
                    path: "/about",
                    element: <AboutUs />,
                },
                {
                    path: "/packing-list",
                    element: <PackingList />,
                },
                {
                    path: "/all-packing-list",
                    element: <AllPackingList />,
                },
                {
                    path: "/user-saved-packing-list",
                    element: <UserSavedPackingList />,
                },
                {
                    path: "/terms-and-condition",
                    element: <TermsAndConditions />,
                },
                {
                    path: "/privacy-policy",
                    element: <PrivacyPolicy />,
                },
                {
                    path: "/trip-detail/:id",
                    element: <TripDetails />,
                },
                {
                    path: "*",
                    element: <NotFound />,
                },
                {
                    element: <PrivateRouteUser />,
                    children: [
                        {
                            path: '/profile',
                            element: <TravellerProfile />
                        },
                    ]
                },
            ],

        },
        {
            element: <AdminLayout />,
            children: [
                {
                    element: <PrivateRouteAdmin />,
                    children: [
                        {
                            path: "/destination",
                            element: <DestinationPage />,
                        },
                        {
                            path: "/itineraries",
                            element: <Itineraries />,
                        },
                        {
                            path: "/tribe",
                            element: <Tribe />,
                        },
                        {
                            path: "/dashboard",
                            element: <Dashboard />,
                        },
                        {
                            path: "/packing",
                            element: <Packing />,
                        },
                        {
                            path: "/traveller",
                            element: <Traveller />,
                        },
                        {
                            path: "/tags",
                            element: <TagPage />,
                        },
                        {
                            path: "/addpackinglist",
                            element: <AddPackingList />,
                        },
                        {
                            path: "/editpackinglist/:id",
                            element: <EditPackingList />,
                        },
                        {
                            path: "/edit-profile-user-admin",
                            element: <EditProfiles />,
                        },
                        {
                            path: "/packing/settings",
                            element: <PackingListSetting />,
                        },
                        {
                            path: "/top-section",
                            element: <TopSections />,
                        },
                        {
                            path: "/badges",
                            element: <BadgesPage />,
                        },
                    ]
                },
                {
                    element: <PrivateRouteTraveller />,
                    children: [
                        {
                            path: "/travel-dashboard",
                            element: <TravellerDashboardMain />,
                        },
                        {
                            path: "/travel-packing",
                            element: <TravellerPackingList />,
                        },
                        {
                            path: "/edit-profile-user",
                            element: <EditProfiles />,
                        },
                    ]
                }

            ]

        },
        {
            path: "/login",
            element: <Login />,
        },
        {
            path: "/sign-up",
            element: <Signup />,
        },
        {
            path: "/edit-profile",
            element: <Updateprofile />,
        },

    ])
    return (
        <RouterProvider router={router} />
    )
}

export default PackingRoutes